<Label :label="$attrs.label" :isHorizontal="$attrs.horizontal"><input v-bind="$attrs" v-model="state" @input="setDirty"></Label>